import { readonly, ref, useContext } from "@nuxtjs/composition-api";
import { Logger } from "@wemade-vsf/core";
import { useApi } from "@wemade-vsf/composables";
import { sortingOptions } from "./sortingOptions";
import { useConfigStore } from "@wemade-vsf/core";
import { createProductAttributeFilterInput } from "./input/createProductAttributeFilterInput";
import { createProductAttributeSortInput } from "./input/createProductAttributeSortInput";
import loadMoreAggregationOptionsGql from "./loadMoreAggregationOptions.gql";
function useFacet() {
  const { app } = useContext();
  const { query } = useApi();
  const loading = ref(false);
  const result = ref({ data: null, input: null });
  const error = ref({
    search: null,
    loadMoreAggregationOptions: null
  });
  const configStore = useConfigStore();
  const search = async (params) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
    const defaultItemsPerPage = ((_a = configStore.storeConfig) == null ? void 0 : _a.grid_per_page) || 12;
    const perPageOptions = ((_b = configStore.storeConfig) == null ? void 0 : _b.grid_per_page_values) ? configStore.storeConfig.grid_per_page_values.split(",").map((a) => parseInt(a)) : [12, 24, 48];
    Logger.debug("useFacet/search", params);
    result.value.input = params;
    try {
      loading.value = true;
      const pageSize = params.itemsPerPage ? params.itemsPerPage : defaultItemsPerPage;
      const includeLabels = (_f = (_e = (_d = (_c = app.$wm) == null ? void 0 : _c.catalog) == null ? void 0 : _d.productList) == null ? void 0 : _e.includeLabels) != null ? _f : true;
      const customAttributes = ((_i = (_h = (_g = app.$wm) == null ? void 0 : _g.catalog) == null ? void 0 : _h.productList) == null ? void 0 : _i.customAttributes) || [];
      const additionalSortingOptions = (_j = app.$wm.catalog.additionalSortingOptions) != null ? _j : [];
      const internalPagination = params.scrolledPage ? {
        pageSize: pageSize * (params.page || 1),
        currentPage: 1
      } : {
        pageSize,
        currentPage: params.page || 1
      };
      const productSearchParams = {
        pageSize: internalPagination.pageSize,
        search: params.term ? params.term : "",
        filter: createProductAttributeFilterInput(params),
        sort: createProductAttributeSortInput(params.sort || ""),
        currentPage: internalPagination.currentPage,
        includeLabels,
        includePagination: false,
        customAttributes,
        isDetailProduct: false,
        includeCategories: false
      };
      const { data } = await app.$vsf.$magento.api.products(productSearchParams);
      const products = (_k = data == null ? void 0 : data.products) != null ? _k : null;
      Logger.debug("[Result]:", { products });
      result.value.data = {
        items: (_l = products == null ? void 0 : products.items) != null ? _l : [],
        aggregations: (_m = products == null ? void 0 : products.aggregations) != null ? _m : [],
        total: products == null ? void 0 : products.total_count,
        availableSortingOptions: [...sortingOptions, ...additionalSortingOptions],
        perPageOptions,
        itemsPerPage: pageSize
      };
      error.value.search = null;
    } catch (err) {
      error.value.search = err;
      Logger.error("useFacet/search", err);
    } finally {
      loading.value = false;
    }
  };
  const loadMoreAggregationOptions = async (attributeCode, params) => {
    var _a, _b, _c;
    let result2 = null;
    loading.value = true;
    const searchParams = {
      attributeCode,
      filter: createProductAttributeFilterInput(params)
    };
    try {
      const res = await query(loadMoreAggregationOptionsGql, searchParams);
      Logger.debug("[Result]", res.data);
      result2 = ((_c = (_b = (_a = res == null ? void 0 : res.data) == null ? void 0 : _a.viewMoreFilter) == null ? void 0 : _b.aggregations) == null ? void 0 : _c[0]) || null;
    } catch (err) {
      error.value.loadMoreAggregationOptions = err;
    } finally {
      loading.value = false;
    }
    return result2;
  };
  return {
    search,
    loadMoreAggregationOptions,
    result,
    error: readonly(error),
    loading: readonly(loading)
  };
}
export * from "./useFacet";
var useFacet_default = useFacet;
export {
  useFacet_default as default,
  useFacet
};
